import "./NameBadgeComp.css";
import { defineComponent as t, openBlock as o, createElementBlock as _, createElementVNode as a, toDisplayString as n } from "vue";
import { _ as s } from "./_plugin-vue_export-helper.dad06003.js";
const i = { class: "nameBadge" }, p = { class: "nameBadge__initials" }, c = /* @__PURE__ */ t({
  __name: "NameBadgeComp",
  props: {
    initials: {
      type: String
    }
  },
  setup(e) {
    return (m, r) => (o(), _("div", i, [
      a("p", p, n(e.initials), 1)
    ]));
  }
});
const B = /* @__PURE__ */ s(c, [["__scopeId", "data-v-27e14861"]]);
export {
  B as NameBadgeComp
};
//# sourceMappingURL=NameBadgeComp.js.map
